import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ColumnKey } from '../../types/column-key';

@Component({
  selector: 'app-table-body-no-reference-cell',
  imports: [],
  templateUrl: './table-body-no-reference-cell.component.html',
  styleUrl: './table-body-no-reference-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableBodyNoReferenceCellComponent<Model> {
  @Input({ required: true }) public columnKey!: ColumnKey<Model>;
}
